import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { catchError, map, of } from 'rxjs';

export const guestGuard: CanActivateFn = (route, state) => {
  const _api = inject(ApiService);
  const _router = inject(Router);

  return _api.post('api/sanctum/check', {}).pipe(
    map((response: any) => {
      console.log('guestGuard CanActivateFn response', response);

      if (!!response.check) {
        _router.navigate(['/admin']);
      }

      return !response.check;
    }),
    catchError((error: any) => {
      console.log('guestGuard CanActivateFn catchError error', error);
      return of(true);
    })
  );
};
